var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cooperative"},[_c('h1',[_vm._v("知识专区")]),_c('div',{staticClass:"plana"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c('a',{attrs:{"href":item.cooperativeUrl,"target":"_blank"}},[_c('img',{staticClass:"img3",attrs:{"src":item.cooperativeImg}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }